export default __webpack_public_path__ + "src/images/line_green-877221.png";